const Preloader = () => (
	<div className="relative h-1 w-full overflow-hidden bg-gray-200/50 dark:bg-gray-700/40">
		<div className="h-full rounded-full bg-primary shadow-[0_0_14px_hsl(var(--primary)/0.4)] animate-[load_1s_normal_forwards]" />
	</div>
)

const GlobalPreloader = () => (
	<div id="preloader" className="relative h-1 w-full shrink-0 overflow-hidden bg-gray-200/50 dark:bg-gray-700/40">
		<div className="h-full rounded-full bg-primary shadow-[0_0_14px_hsl(var(--primary)/0.4)] animate-[load_1s_normal_forwards]" />
	</div>
)

export { GlobalPreloader }
export default Preloader
